import { FormStepper } from "../../../../common";

export const ProgressSection = ({
  step,
  stepList = [],
  setStep = () => {},
}) => {
  return (
    <>
      <FormStepper
        currentStep={step}
        steps={stepList}
        naviagetToStep={setStep}
      />
    </>
  );
};
